module.exports = __webpack_public_path__ + "static/media/icon_hensyuu.b3382301.svg";